import { GetServiceAgreementListResponse } from 'pco-product-service-internal-consumer';
import { serviceAgreementApi } from 'api';

export const getServiceAgreementList = async (params: {
  partnerUid?: string;
  businessRelationUid?: string;
}): Promise<GetServiceAgreementListResponse> => {
  return await serviceAgreementApi.getServiceAgreements({
    partnerUid: params.partnerUid,
    businessRelationUid: params.businessRelationUid,
  });
};
